export const hoverBackgroundPlugin = {
  id: 'hoverBackground',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  beforeDraw: (chart: any) => {
    const activeElements = chart.getActiveElements()
    if (activeElements.length > 0) {
      const ctx = chart.ctx
      const chartArea = chart.chartArea
      const hoveredIndex = activeElements[0].index
      const barWidth =
        (chartArea.right - chartArea.left) / chart.data.labels.length
      const barX = chartArea.left + hoveredIndex * barWidth

      const activeElement = activeElements[0]
      const barPosition = activeElement.element.y

      ctx.save()
      ctx.fillStyle = '#F2F2F2'
      ctx.beginPath()
      ctx.roundRect(
        barX,
        chartArea.top,
        barWidth,
        barPosition - chartArea.top,
        [0, 0, 8, 8],
      )
      ctx.fill()
      ctx.restore()
    }
  },
}
